import Config from "@/services/Config";

export default {
    label: {
        agreement: {
            fx: {
                fxIntro: "いつも「みんなのＦＸ」をご愛顧いただき、誠にありがとうございます。<br>この度、弊社では、お客様へ交付する書面等の内容を一部改訂しております。つきましては、次の各書面の内容を熟読し、本取引の仕組み、リスク等を十分にご理解いただいた上で、ご自身の責任と判断にてお取引を開始されますようお願いいたします。",
                regulationFxattention: "店頭外国為替証拠金取引に係るご注意",
                regulationOverview: "店頭外国為替証拠金取引説明書",
                regulationRules: "店頭外国為替証拠金取引約款",
                regulationKeiyakumaekofu: "契約締結前交付書面",
                regulationKomonkeiyaku: "投資顧問契約書兼契約締結時交付書面",
                regulationTraderAgreement: "取引情報開示及び提供についての留意点並びに同意規約",
                regulationHansya: "反社会的勢力でないことの確認に関する同意書",
                tscPrivacy: "個人情報保護方針",
                transactions: "取引に関する重要事項の確認",
                transactionContent: "<p>FX取引は、レバレッジを効かせた取引であるため大きな収益を期待できる一方、損失額が預託した証拠金を上回る可能性がある等、取引の特性や仕組み、リスクを理解しました。</p><hr /><p>お客様と弊社の間を結ぶ通信回線等に障害が発生した場合には、取引の執行ができなかったり、相場情報の配信に遅延等の障害が生じる場合があることを理解しました。</p><hr /><p>ロスカットは、必ずしも当社規定のロスカット基準額で執行されるとは限らず、相場の急激な変動により、預託証拠金額以上の損失が発生する場合があることを理解しました。</p><hr /><p>社内規定等でデリバティブ取引が禁じられていないことを誓約します。</p>",
                confirmTitle: "確認書",
                confirmContent1: "1．私は店頭外国為替証拠金取引に関する「取引説明書」及び「取引約款」の内容を確認し、各取引の仕組み、内容、リスク等を十分に理解した上で、私の判断と責任において当該取引を行います。",
                confirmContent2: "2．居住地国及び納税義務は日本であり、かつ米国籍及び米国永住権は保有していません。また、",
                confirmContent3: "3．本申込における取引は、法人としての取引であり、個人としての取引ではありません。",
                loanBorrowAccount: "名義貸し・借名口座について",
                foreignPEPs: "外国PEPs",
                applyNoteFX1: "に該当しません。",
                applyNoteFX2: "※居住地国及び納税義務が日本以外の場合、米国籍及び米国永住権を保有している場合、並びに外国PEPsに該当する場合は口座開設及び取引できません。 ",
                applyNoteFX3: "また、法人の場合、法人としての情報のみならず、法人代表者、取引担当者及び実質的支配者においても上記に該当する場合は口座開設及び取引できません。",
                regulationCrs: "特定取引を行う者の届出書",
            },

            bo: {
                boIntro: "いつも「みんなのオプション」をご愛顧いただき、誠にありがとうございます。 <br>この度、弊社では、お客様へ交付する書面等の内容を一部改訂しております。つきましては、次の各書面の内容を熟読し、本取引の仕組み、リスク等を十分にご理解いただいた上で、ご自身の責任と判断にお取引を開始されますようお願いいたします。",
                regulationBoattention: "店頭通貨バイナリーオプション取引に係るご注意",
                regulationOverviewOp: "店頭通貨バイナリーオプション取引説明書",
                regulationRulesOp: "店頭通貨バイナリーオプション取引約款",
                confirmOptionTrading: "みんなのオプション取引（店頭通貨バイナリーオプション取引）に関する確認",
                confirmContent1: "1.私は、みんなのオプション取引（以下「本取引」という）に関し、その対象となる金融指標等を含む基本的なスキームについて、十分な説明を受け、理解しました。 （「取引説明書」「取引約款」参照）",
                confirmContent2: "２.私は、本取引に関し、特に次に掲げる事項について、十分な説明を受け、理解しました。<br>① 本取引が期日のある取引であること<br>（取引説明書「本件オプション取引のリスク等重要事項について」参照）",
                confirmContent3: "②取引期間中のオプション価格は変動すること<br>（取引説明書「本件オプション取引のリスク等重要事項について」参照）",
                confirmContent4: "③購入したバイナリーオプションについて、判定時刻においてお客様の予測と一致しなかった場合には、投資元本がゼロになること<br>（取引説明書「本件オプション取引のリスクについて」参照）",
                confirmContent5: "④購入したバイナリーオプションについて、判定時刻前に売却（または解約）した場合には、売却金額（清算金額）が購入金額を下回り、損失が生じるおそれがあること<br>（取引説明書「本取引システムを利用した本件オプション取引にかかるリスクについて」参照）",
                confirmContent6: "⑤本取引について、トレイダーズ証券と取引する顧客全体が支払う金額と受け取る金額の差額が、トレイダーズ証券の収益の源泉となっていること<br>（取引説明書「本取引システムを利用した本件オプション取引にかかるリスクについて」参照）",
                confirmContent7: "⑥本取引について、合理的な投資判断をもって行うためには、オプション取引の理論的根拠などに関する専門知識が必要であること<br>( 取引説明書「本取引システムを利用した本件オプション取引にかかるリスクについて」参照）",
                confirmContent8: "３.本取引により想定される損失額（途中売却または解約した場合の損失解約清算金（試算額）を含む。）を踏まえ、 私が許容できる損失額及び私の資産の状況への影響に照らして、私が取引できる契約内容であることを確認しました。",
                confirmContent9: "私は、上記1～3を踏まえ、私の判断と責任において契約を締結することをここに確認いたします。",
            },

            cryptoFX: {
                cryptoFXIntro: "いつもみんなのコインをご愛顧いただき、誠にありがとうございます。<br>この度、弊社では、お客様へ公布する書類などの内容を一部改訂しております。つきましては、次の内容を熟読し、本取引の仕組み、リスク等を十分ご理解いただいた上で、ご自身の責任と判断でお取引を開始されますようお願いいたします。",
                regulationCryptoFX: "各種規定の確認・承諾",
                regulationAttentionCoin: "店頭暗号資産証拠金取引に係るご注意",
                regulationOverviewCoin: "店頭暗号資産証拠金取引説明書",
                regulationRulesCoin: "店頭暗号資産証拠金取引約款",
                regulationInsiderCoin: "暗号資産内部者でないことの確認に関する同意書",
                coinTrading: "みんなのコイン取引（店頭暗号資産証拠金取引）に関する確認",
                confirmContent1: "暗号資産は本邦通貨または外国通貨（法定通貨）とは異なり、特定の国等によりその価値が保証されているものではなく、強制通用力を有しないことを理解しました。 ",
                confirmContent2: "暗号資産の価値は需給関係や様々な外部環境の変動によって常に変動するほか、プログラムに脆弱性や不具合が生じる可能性、悪意のある者による不正な取引等が行われる可能性等、予見の困難な事象により、暗号資産の価値が大きく下落するまたはゼロになる可能性があることを理解しました。 ",
                confirmContent3: "暗号資産には、ハードフォークにより暗号資産が2つに分岐し、相互に互換性がなくなる可能性があり、その場合、大幅な価値下落や取引が遡って無効になるリスクがあることを理解しました。 ",
                confirmContent4: "暗号資産証拠金取引は、元本や利益を保証するものではなく、レバレッジの効果により預託する証拠金の額以上の取引が可能となりますが、相場変動等により預託した証拠金の額を上回る損失が発生するおそれがあることを理解しました。 ",
                confirmContent5: "暗号資産証拠金取引において当社が提示する売付価格と買付価格には価格差（スプレッド）があり、相場変動等によりスプレッドが拡大する場合があり、お客様が意図する取引ができない可能性があることを理解しました。",
                confirmContent6: "証拠金不足が発生した場合、規定の証拠金維持率を回復するまで約定日時の古い建玉から順次決済が行われること（ロスカットの仕組み）を理解しました。 ",
                confirmContent7: "ロスカットは必ずしもお客様の損失を限定するものではなく、相場変動等により、預託した証拠金以上の損失が発生するおそれあることを理解しました。 ",
                confirmContent8: "以下が禁止行為であることを理解しました。",
                confirmContent9: "・お客様自身の名義で、ご家族を含む第三者に取引口座の開設及び取引をさせることはできないこと。",
                confirmContent10: "・お客様自身の名義以外で、ご家族を含む第三者からのご入金は受付けられないこと。",
            },

            confirmationOfRegistrationInformation: "登録情報の確認について",
            InformationContent1: "現在の登録情報（住所・電話番号・メールアドレス・投資可能資産・年収等）に相違なく、今後、登録情報に変更があった場合は速やかに変更手続きを行うものとし、変更手続きを行っていない場合には取引に制限がかかる場合があることを了承いたします。登録情報の変更は、マイページの「お客様情報」からお手続きください。",
            agreementNote1: "上記内容でよろしければ、「マイページへ」をクリックしてください。",
            agreementNote2: "また、上記内容でご承諾いただけない場合は、以下連絡先までお電話をお願いいたします。",
            regulationFX_BO_CryptoFX: "各種規程の確認・承諾"
        },

        cryptoRegistration: {
            webTraderTitle: "ウェブトレーダー",
            downloadAppNote: "ウェブトレーダーは準備中です。お待ちください。",
            cryptoNote: "誠に残念ながら、当社サービス「みんなのコイン」のご利用をお勧めできないと判断させていただきました。<br/>またの機会がございましたら改めてよろしくお願い申上げます。",
            descriptionTitle: "お申込みありがとうございます。",
            descriptionContent: "「みんなのコイン」のご利用にあたり、口座開設審査をさせていただきます。<br/><br/>審査が完了しましたら、ご登録のメールアドレス宛にご連絡いたします。<br/>恐れ入りますが、審査完了まで今しばらくお待ちください。<br/>※開設にあたりマイナンバー（個人番号）の登録が必要となります。<br/><br/>本画面は口座開設完了後に画面が切替りますので、口座開設完了まで今しばらくお待ちください。",
            deliveryAddressTitle: "送付先",
            deliveryContent: "〒{company_zipcode}<br>{company_address_1}&nbsp;{company_address_2}<br>{company_name}<br><br>",
            deliveryNote: "※各送付方法に関する注意事項は",
            cancelOpenAccountNote: "「みんなのコイン」の口座開設申込みを取消させていただきました。<br />またの機会がございましたら改めてよろしくお願い申上げます。<br />なお、再申込みをご希望の場合には、以下連絡先までお電話をお願いいたします。<br />{company_tel}",
            closeAccountNote: "ログインが制限されています。以下連絡先までお電話ください。<br />{company_tel}",
        },

        postDoc: {
            verificationCodeTitle: "本人確認コードの入力",
            note: "お受取いただいた郵送書類に記載の本人確認コードを送信してください。",
            messageErrorText: "本人確認コードが誤っています",
            btnResend: "再送信する",
            verificationCompleted: "本人確認完了",
            paymentTransactionsPossible: "ご入金およびお取引が可能です。",
            btnOK: "OK",
            messageNotify: "本人確認コードご確認の上、再送信してください。"
        }

    },
    "login.label.header": "会員ログイン",
    "login.label.username" : "ログインID",
    "login.label.password" : "パスワード",
    "login.label.forgot_pass":"パスワードをお忘れの方はこちら",

    "currency.japanese.yen": "円",
    "people.japanese.symbol": "人",
    "people.japanese.symbol2": "名",

    "label.please_select": "選択してください",
    "label.max_loss_amount.unit": "万円",

    "date.picker.from": "検索開始日",
    "date.picker.to": "検索終了日",

    "btn.run": "実行",
    "btn.ok": "はい",
    "btn.cancel": "キャンセル",
    "btn.close_windown": "ウィンドウを閉じる",
    "btn.search": "検索",
    "btn.update": "アップデート",
    "btn.delete": "削除",
    "btn.agree": "応ずる",
    "btn.agreement.news.agree": "承諾する",
    "btn.close": "閉じる",
    "btn.mypage": "マイページへ",
    "btn.go_to_profile": "お客様情報へ",
    "btn.agreeTest": "承諾する",
    "btn.modify": "修正する",
    "btn.determination": "判定結果",
    "btn.confirmTest": "未回答の項目があります",
    "btn.see_more": "もっと見る",
    "btn.go_to_confirm": "確認画面へ",
    "btn.go_to_cancel": "承諾しない",
    "btn.back": "戻る",
    "btn.regist": "登録",
    "btn.change.login.id.ok": "はい",
    "btn.change.login.id.cancel": "いいえ",
    "btn.change.login.id.success": "閉じる",
    "button.save": "保存",
    "button.cancel": "取消",
    "confirmation.box.title": "確認",

    "radio.yes": "o",
    "radio.no": "×",
    "default.combo.box": "全て",

    "account.ams": "入出金口座",
    "account.copytrade": "シストレ口座",
    "account.ntdfx": "FX口座",
    "account.cryptofx": "コイン口座",
    "account.bo": "オプション口座",
    "account.fx": "FX口座",

    "report.unread.yes": "はい ",
    "report.unread.no": "いいえ",

    "report.cb.service.type": "--- 種別 ---",
    "report.cb.service.type.ams": "AMS",
    "report.cb.service.type.bo": "BO",
    "report.cb.service.type.social": "MT4 Social",
    "report.cb.service.type.ntd_fx": "NTD FX",
    "report.cb.report.type": "--- 報告書タイプ ---",
    "report.cb.report.type.d": "日次",
    "report.cb.report.type.m": "月次",
    "report.cb.report.type.y": "年次",
    "report.cb.report.type.report_daily": "日次",
    "report.cb.report.type.report_monthly": "月次",
    "report.cb.report.type.report_yearly": "年次",
    "report.cb.unread": "--- 未閲覧のみ ---",
    "report.cb.account.type.fx": "FX / ST",
    "report.cb.account.type.st": "シストレ",
    "report.cb.account.type.bo": "オプション",
    "report.cb.account.type.crypto": "コイン",
    "report.cb.account.type.ams": "入出金",
    "report.cb.account.type.bo.mt4": "BO",
    "report.cb.account.type.ntdfx": "FX",
    "report.cb.account.type.sc": "シストレ口座",
    "report.table.account.type.1": "シストレ",
    "report.table.account.type.2": "オプション",
    "report.table.account.type.3": "FX",
    "report.table.account.type.4": "入出金",
    "report.table.account.type.5": "コイン",
    "report.table.account.type.mt4.1": "FX",
    "report.table.account.type.mt4.2": "BO",
    "report.table.account.type": "口座",
    "report.textnote": "※2016年6月11日以前に作成されたトレード口座の報告書はシストレ口座の報告書にてご確認いただけます。",
    "report.textnote.internalSC": "「※{param1}以前に作成されたシストレ口座の報告書は入出金口座の報告書にてご確認いただけます。」",
    "report.textnote.publicSC": "※2016年6月11日以前のトレード口座の報告書、および{param1}以前のシストレ口座の報告書は、入出金口座の報告書にてご確認いただけます。",

    "report.title.mypage": "マイページ",
    "report.title.reports": "Reports",
    "report.label.date": "日付",
    "report.label.not_viewing_only": "未閲覧のみ",
    "report.label.report_type": "種類",
    "report.label.title": "タイプ",
    "report.label.report_file": "ファイル",
    "report.label.search": "検索",
    "report.label.ok": "はい",
    "report.label.no": "いいえ",
    "report.label.period": "期間",
    "report.label.type": "種類",
    "report.label.unread": "未閲覧のみ",
    "report.label.day.month.year.report": "日次、月次、年次",
    "report.label.period.report": "期間損益",
    "report.label.period.buy": " 購入金額",
    "report.label.period.get": "受取金額",
    "report.label.period.total.bottom": "【実現損益累計額】",
    "report.label.period.cashBack": "キャッシュバック報酬",
    "report.label.header.partSpotSwapPL": "【実現損益】",
    "report.label.period.totalRealizedPL": "【実現損益累計額】",
    "report.label.period.spotPL": "売買損益",
    "report.label.period.swapPL": "スワップ損益",
    "report.label.period.openInterestManagementFee": "建玉管理料（税込）",
    "report.label.period.unsettledOpenInterestManagementFee": "未決済建玉管理料",
    "report.label.period.adjustmentMoney": "その他損益",
    "report.label.period.comissionFee": "手数料",
    "report.label.period.advisorFee": "助言手数料",
    "report.table.period.total": "取引損益累計額",
    "report.label.period.UnRealized": "【建玉未実現損益】",
    "report.label.period.UnRealized.spotPL": "建玉評価損益",
    "report.label.period.UnRealized.swapPL": "未決済スワップ",
    "report.label.period.total.UnRealized&&Realized": "【実現損益と建玉評価損益・未決済スワップの合計】",
    "report.label.period.total.cryptoUnRealized&&Realized": "【実現損益と建玉未実現損益の合計】",
    "report.periodReportTextNote": "過去2年間（730日）の期間損益報告書がご確認いただけます。",
    "report.textnote1": "■2017年11月25日以前に、みんなのＦＸをご利用いただいていたお客様",
    "report.textnote2": "・2014年以降の報告書は、以下連絡先までお問合せください。",
    "report.textnote3": "■2017年11月25日以前に、みんなのシストレをご利用いただいていたお客様",
    "report.textnote4": "・2016年6月11日以前のトレード口座の報告書は、入出金口座の報告書にてご確認いただけます。",
    "report.textnote5": "・2016年9月3日以前のシストレ口座の報告書は、入出金口座の報告書にてご確認いただけます。",
    "report.asked.questions": "よくあるご質問はこちら",
    "report.asked.questions.link": `${Config.getReportHelpUrl()}`,
    "report.label.period.and.pl.1": "・確定申告の際は、 報告書を添付いただく必要はございません。期間損益で年間検索のうえ、「取引損益累計額」の金額をご申告ください。",
    "report.label.period.and.pl.2": "・報告書の見方については<a href=\"{reportSupportLink}\" target=\"_blank\">こちら</a>をご覧ください。",
    "report.label.period.and.warn": "報告書の出力にはパスキー認証またはワンタイムパスワード認証が必要です。",

    "navigation.bt.next": "次へ",
    "navigation.bt.previous": "前へ",
    "navigation.bt.first": "最初",
    "navigation.bt.last": "最後",

    "calendar.bt.today": "今日",
    "calendar.bt.close": "クローズ",
    "calendar.bt.clear": "クリア",

    "profile.title.header": "お客様情報",
    "profile.format.date_time": "YYYY年MM月DD日",
    "profile.label.change": "変更",
    "profile.label.upload": "提出",
    "profile.label.my_profile": "私のプロフィール",
    "profile.label.avatar": "Avatar",
    "profile.label.account_id": "口座番号",
    "profile.label.social_account": "シストレ口座",
    "profile.label.bo_account": "オプション口座",
    "profile.label.crypt_account": "コイン口座",
    "profile.label.fx_account": "FX口座",
    "profile.label.leverage": "レバレッジ",
    "profile.label.ntd_account": "ＦＸ口座",
    "profile.label.real_name": "お客様氏名",
    "profile.label.corp.real_name": "法人名",
    "profile.label.phone_number": "電話番号",
    "profile.label.phone_number2": "電話番号②",
    "profile.label.email": "メインメール",
    "profile.label.additional_email": "追加メール",
    "profile.label.account_open_date": "口座開設日",
    "profile.label.financial_assets": "金融資産",
    "profile.label.investment_amount": "投資可能金額",
    "profile.label.financial_assets_and_investment_amount": "金融資産・投資可能金額",
    "tooltip.financial_assets": "金融資産とは、固定資産を含まない流動資産のうち生活資金を除いた余剰金額を指します。",
    "profile.pic.label.self_assets": "事業体の自己資本",
    "tooltip.investment_amount": "トレイダーズ証券のサービスへお預けを予定している金額",
    "profile.label.question_investment_amount": "投資資金はご自身の資産でお間違いありませんか？",
    "profile.label.investment_purposes": "FX投資目的",
    "profile.label.crypto": "コイン投資目的",
    "profile.label.crypto.force.news": "暗号資産CFD投資目的",
    "profile.label.password": "ログインパスワード",
    "profile.label.password2": "!!",
    "profile.label.verify.authenticator": "認証を行う",
    "profile.label.new_password": "新しいパスワード",
    "profile.label.new_password2": "第2パスワード入力",
    "profile.label.change_profile": "プロファイルの変更",
    "profile.label.my_number.individual": "マイナンバー",
    "profile.label.my_number.corporation": "法人番号",
    "profile.label.my_number_personal.individual": "マイナンバー <br>（個人番号）",
    "profile.label.my_number_personal.corporation": "法人番号",
    "profile.label.upload.mynumber.new.individual": "2015年12月以前に口座開設しマイナンバー（個人番号）が未提出のお客様は、マイナンバー書類を提出する必要があります。個人口座の場合、「通知カード（表面）」「個人番号カード（裏面）」「個人番号付住民票の写し」のいずれかを送信してください。氏名を変更している場合は、「通知カード」「個人番号カード」共に両面必要です。<br>※提出書類の詳細は、<a href=\"https://min-fx.jp/support/flow/document/\" target=\"_blank\">必要書類について</a>をご覧ください。 ",
    "profile.label.upload.mynumber.new.corporation": "2015年12月以前に口座開設し法人番号が未提出のお客様は、法人番号書類を提出する必要があります。法人口座の場合、「法人番号指定通知書」「法人番号印刷書類」のいずれかを送信してください。<br>※提出書類の詳細は、<a href=\"https://min-fx.jp/support/flow/document/\" target=\"_blank\">必要書類について</a>をご覧ください。 ",
    "profile.label.my_number.unregistered": "未登録",
    "profile.label.my_number.registered": "登録済",
    "profile.label.my_number.delete": "抹消",
    "profile.investment.purpose_short_term_flg": "短期売買",
    "profile.investment.purpose_long_term_flg": "中長期運用",
    "profile.investment.purpose_exchange_flg": "為替差益重視",
    "profile.investment.purpose_swap_flg": "スワップ重視",
    "profile.investment.purpose_hedge_asset_flg": "外貨資産ヘッジ",
    "profile.investment.purpose_high_int_flg": "高金利通貨メイン",
    "profile.investment.purpose_economic_flg": "グローバルな経済感覚を養うため",
    "profile.bo_investment_purpose.bo_purpose_short_term_flg": " 短期収益の重視",
    "profile.bo_investment_purpose.bo_purpose_disp_asset_mng_flg": " 分散した資産運用",
    "profile.bo_investment_purpose.bo_purpose_hedge_flg": " ヘッジ目的",
    "profile.bo_investment_purpose.crypto_purpose_fluctuation_flg": " 暗号資産の価格変動による売却益のため",
    "profile.bo_investment_purpose.crypto_purpose_diverse_flg": " 分散投資を行うため",
    "profile.bo_investment_purpose.crypto_purpose_asset_flg": " 資産形成のため",
    "profile.label.bo_investment_purpose": "BO投資目的",
    "profile.label.representative_name": "代表者氏名",
    "profile.label.benefic_type": "対象となる自然人",
    "profile.label.benefic_owner": "実質的支配者の有無",
    "profile.label.benefic_owner2": "実質的支配者の追加",
    "profile.label.benefic_owner3": "実質的支配者の追加",
    "profile.label.benefic_owner4": "実質的支配者の追加",
    "profile.label.person_in_charge_name": "担当者氏名",
    "profile.label.person_in_charges_name": "担当者氏名",
    "profile.label.pic_address": "担当者住所",
    "profile.label.pic_phone": "担当者電話番号",
    "profile.label.retype_password": "新しいパスワードを再入力",
    "profile.label.retype_password2": "第2パスワード再入力",
    "profile.label.corporation_name": "法人名",
    "profile.label.corporation_name_kana": "法人名（カナ）",
    "profile.label.postal_code": "郵便番号",
    "profile.label.perfecture": "都道府県",
    "profile.label.city": "市区郡・町村",
    "profile.label.address": "ご登録住所",
    "profile.corp.label.address": "法人住所",
    "profile.label.building_name": "マンション名・部屋番号",
    "profile.benefit_ownder.no": "無し",
    "profile.benefit_ownder.yes": "有り",
    "profile.benefit_owner.type.idv": "個人",
    "profile.benefit_owner.type.corp": "法人",
    "profile.benefit_owner.type.other": "その他",
    "profile.benefit_ownder_other.no": "しない",
    "profile.benefit_ownder_other.yes": "する",
    "profile.label.pic_last_name": "姓",
    "profile.label.pic_first_name": "名",
    "profile.label.last_name": "姓",
    "profile.label.first_name": "名",
    "profile.label.pic_last_name_kana": "姓（カナ）",
    "profile.label.pic_first_name_kana": "名（カナ）",
    "profile.label.last_name_kana": "姓（カナ）",
    "profile.label.first_name_kana": "名（カナ）",
    "profile.label.pic_postal_code": "郵便番号",
    "profile.label.pic_perfecture": "都道府県",
    "profile.label.pic_city": "市区郡・町村",
    "profile.label.pic_building_name": "マンション名・部屋番号",
    "profile.show.change.password": "Change Password",
    "profile.label.current_password": "現在のパスワード",
    "profile.label.section": "番地等",
    "profile.label.pic_section": "番地等",
    "profile.label.existence_benefic_owner": "実質的支配者",
    "profile.label.benefic_name": "氏名",
    "profile.label.benefic_name_kana": "氏名（カナ）",
    "profile.label.benefic_first_name": "名",
    "profile.label.benefic_first_name_kana": "名（カナ）",
    "profile.label.benefic_last_name": "姓",
    "profile.label.benefic_last_name_kana": "姓（カナ）",
    "profile.label.benefic_owner_establish_date": " 生年月日",
    "profile.label.benefic_owner_zipcode": "郵便番号",
    "profile.href.postal_code_reference": "郵便番号を探す",
    "profile.label.benefic_owner_prefecture": "都道府県",
    "profile.label.benefic_owner_city": "市区郡・町村",
    "profile.label.benefic_owener_section": "番地等 ",
    "profile.label.benefic_owener_building_name": "マンション名・部屋番号",
    "profile.label.benefic_phone": "電話番号 ",
    "profile.gender.female": "女性",
    "profile.gender.male": "男性",
    "profile.label.gender": "性別",
    "profile.label.date_of_birth": "誕生日",
    "profile.label.representatives_name": "代表者氏名",
    "profile.message.notify.change.mail": "※メインメールアドレスをログインIDとして使用している場合、メールアドレスを変更するとログインIDも変更されます。変更する前に、メールアドレスにお間違えがないか再度ご確認ください。",
    "profile.label.file_input_new": "ファイルを選択",
    "profile.label.file_input_exists": "変更",
    "profile.label.file_input": "取り除く",
    "profile.label.file_input_mn": "削除",
    "profile.label.after_upload.new": "氏名変更をされる場合、変更後の氏名が記載されている本人確認書類のご提出が必要です。上のアップロードフォームより送信をお願いいたします。",
    "profile.label.after_upload.corp": "法人住所が変更となる場合は、変更後の住所が記載されている履歴事項全部証明書（発行から3か月以内）をご郵送いただく必要があります。書類が届き次第、変更手続きをいたします。宛先は",
    "profile.label.after_upload": "※アップロード以外の送付方法や提出書類の詳細は、",
    "profile.label.address.invidual.after_upload.1": "住所変更をされる場合、変更後の住所が記載されている本人確認書類のご提出が必要です。上のアップロードフォームより送信をお願いいたします。また、マイナンバー（個人番号）が未提出のお客様は、原則、住所変更の際にマイナンバー書類のご提出も必要となります。本ページ下部の提出ボタンより送信をお願いいたします。",
    "profile.label.address.invidual.after_upload.2": "※アップロード以外の送付方法や提出書類の詳細は、",
    "profile.label.address.invidual.after_upload.3": "また、マイナンバーを未提出の方は、住所変更の際にマイナンバーのご提示も必要となります。",
    "profile.label.address.invidual.after_upload.4": "より送信をお願いいたします。アップロードフォーム以外の送付方法は、",
    "profile.label.address.corporation.after_upload.1": "法人住所を変更される場合、変更後の住所が記載されている履歴事項全部証明書（発行から3ヶ月以内の原本）のご郵送が必要です。また、法人番号指定通知書を未提出の方に限り、ご郵送の際に法人番号指定通知書のコピーを同封ください。郵送の宛先や提出書類の詳細は、",
    "profile.label.address.corporation.after_upload.2": "※お送りいただきました書類は返却いたしません。予めご了承ください。",
    "profile.label.address.corporation.after_upload.3": "また、法人番号通知書類を未提出の方は、住所変更の際にご提出いただく必要があります。",
    "profile.label.address.corporation.after_upload.4": "より送信をお願いいたします。アップロードフォーム以外の送付方法は、",
    "profile.label.address.corporation.after_upload.5": "をご覧ください。",
    "profile.label.address.corporation.after_upload.6": "より送信をお願いいたします。",
    "profile.label.address.corporation.after_upload.7": "アップロードフォーム以外の送付方法は、",
    "profile.label.address.corporation.after_upload.8": "をご覧ください。",
    "profile.label.address.corporation.after_upload.9": "こちらの専用アップロードフォーム ",
    "profile.label.corpname.after_upload": "法人名を変更される場合、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内）のご提出が必要です。上のアップロードフォームより送信をお願いいたします。アップロード以外の送付方法や提出書類の詳細は、",
    "profile.label.corpname.after_upload.footer": "※お送りいただきました書類は返却いたしません。予めご了承ください。",
    "profile.label.address.after_upload_link": "こちらのアップロードフォーム",
    "profile.label.after_upload_link": "こちら",
    "profile.label.after_upload_link.1": "お問合せフォーム",
    "profile.label.after_upload_footer": "をご覧ください。",
    "profile.pic.after_upload": "また、取引担当者と代表者が同一の場合は、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内の原本）のご郵送も必要です。郵送の宛先や提出書類の詳細は、",
    "profile.pic.after_upload2": "取引担当者の氏名を変更される場合、変更後の氏名が記載されている本人確認書類のご提出が必要です。上のアップロードフォームより送信をお願いいたします。アップロード以外の送付方法や提出書類の詳細は、",
    "profile.pic.after_upload_footer": "をご覧ください。",
    "profile.pic.after_upload_footer2": "※お送りいただきました書類は返却いたしません。予めご了承ください。",
    "profile.pic.address.after_upload": "取引担当者の住所を変更される場合、変更後の住所が記載されている本人確認書類のご提出が必要です。上のアップロードフォームより送信をお願いいたします。アップロード以外の送付方法や提出書類の詳細は、",
    "profile.pic.address.after_upload2": "また、取引担当者と代表者が同一の場合は、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内の原本）のご郵送も必要です。郵送の宛先や提出書類の詳細は、",
    "profile.pic.address.after_upload_footer": "をご覧ください。",
    "profile.pic.address.after_upload_footer2": "※お送りいただきました書類は返却いたしません。予めご了承ください。",
    "profile.rep.after_upload": "代表者氏名を変更される場合、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内）のご提出が必要です。上のアップロードフォームより送信をお願いいたします。アップロード以外の送付方法や提出書類の詳細は、",
    "profile.rep.after_upload2": "※お送りいただきました書類は返却いたしません。予めご了承ください。",
    "profile.rep.after_upload_footer": "をご覧ください。",
    "profile.button.submit": "変更",
    "profile.button.submit.pass2": "第2パスワード設定",
    "profile.button.cancel": "キャンセル",
    "profile.button.verify": "変更依頼",
    "profile.button.change": "変更依頼",
    "profile.button.mn": "送信",
    "profile.label.unit.leverage": "倍",
    "profile.bopurposehedgetype.fx": "ＦＸ",
    "profile.bopurposehedgetype.stock": "株式",
    "profile.bopurposehedgetype.commodity": "先物",
    "profile.bopurposehedgetype.foreign_currency": "外貨",
    "profile.bopurposehedgetype.corporate_bond": "公社債",
    "profile.label.please_select": "選択してください",
    "profile.label.bo_loss_maximum_amount": "BO損失上限額",
    "profile.label.max_loss_amount.unit": "万円",
    "profile.label.self_assets.unit": "未満",
    "profile.label.upload.title": "本人確認書類",
    "profile.label.mail":"メールアドレス",
    "profile.label.mail_confirm": "メールアドレス（確認）",
    "profile.title.mypage": "マイページ",
    "profile.title.edit_profile": "Edit Profile",
    "profile.benefic.note.1": "実質的支配者とは、25％を超える議決権を有する自然人が該当します。詳細は",
    "profile.benefic.note.2": "をご確認ください。",
    "profile.benefic.note.3": "なお、実質的支配者なる自然人が個人以外の場合、お手数ではございますが",
    "profile.benefic.note.4": "よりご連絡をお願いいたします。",
    "profile.benefic.label.title.0": "実質的支配者",
    "profile.benefic.label.title.1": "実質的支配者1",
    "profile.benefic.label.title.2": "実質的支配者2",
    "profile.benefic.label.title.3": "実質的支配者3",
    "profile.benefic.label.title.4": "実質的支配者4",
    "profile.require.document": "必要書類について",
    "profile.label.verify.code": "検証コード",
    "profile.label.sendMailInfoFlg": "メルマガ配信",
    "profile.label.sendMailInfoFlg.inactive": "送信しない ",
    "profile.label.sendMailInfoFlg.active": "送信する",
    "profile.label.sendMailInfoFlg.edit": "メルマガ配信",
    "profile.label.sendMailInfoFlg.note": "メールマガジンの配信設定",
    "profile.label.sendMailInfoFlg.warning": "配信停止の反映までに、メールマガジンが配信される場合がございます。予めご了承ください。",
    "profile.label.2Fa.title": "!!",
    "profile.label.Pass2_2Fa.title": "!!",
    "profile.label.2Fa.flg": "Google 認証システム",
    "profile.label.2Fa.qr_code.title": "1．ダウンロード完了後、QRコードの読取りまたは認証キーの入力、いずれかの方法にて認証コード（6桁の数字）を取得してください。",
    "profile.label.2Fa.qr_code": "QR コード",
    "profile.label.2Fa.qr_code.note1": "■QRコードを使用する場合",
    "profile.label.2Fa.qr_code.note1_1": "Google Authenticatorのアプリを開き、「バーコードをスキャン」を選択のうえ、QRコードをスキャンしてください。",
    "profile.label.2Fa.qr_code.note2": "■認証キーを使用する場合",
    "profile.label.2Fa.qr_code.note2_1": "Google Authenticatorのアプリを開き、「手動で入力」を選択のうえ、以下の認証キーを手入力してください。",
    "profile.label.2Fa.authen_key": "認証キー",
    "profile.label.2Fa.verify_code.title": "2．取得した認証コード（6桁の数字）を入力してください。",
    "profile.label.2Fa.verify_code.title_1": "3．取得した認証コード（6桁の数字）を入力してください。",
    "profile.label.2Fa.verify_code": "認証コード",
    "profile.label.2Fa.app.note1": "2段階認証を利用することによって、セキュリティの強化を図ることが可能です。",
    "profile.label.2Fa.app.note1_1": "1.Google Authenticatorのアプリを開く(インストール)",
    "profile.label.2Fa.app.note1_2": "※お手持ちのスマートフォン(iOS/Android)にGoogle Authenticatorをインストールすることで、ご利用いただけます",
    "profile.label.2Fa.app.note2": "※スマートフォンをお持ちの方のみ、ご利用いただけます。",
    "profile.label.2Fa.app.note3": "お持ちのスマートフォンより、Google Authenticatorのアプリをダウンロードしてください。",
    "profile.label.2Fa.app.note4_1":"※iOS15をご利用の場合、当社のアプリ画面からGoogle Authenticatorのアプリ画面に遷移しない場合がございます。",
    "profile.label.2Fa.app.note4_2":"当社のアプリ画面からGoogle Authenticatorのアプリ画面に遷移しない場合には、Google Authenticatorのアプリを手動で立ち上げて認証コードをご入力ください。",
    "profile.label.2Fa.app.init.note1": "2段階認証を利用することによって、セキュリティの強化を図ることが可能です。",
    "profile.label.2Fa.app.init.note2": "※スマートフォンをお持ちの方のみ、ご利用いただけます。",
    "profile.label.2Fa.app.name": "Google Authenticator",
    "profile.label.2Fa.authen_key.note": "※このコードは、2段階認証を有効するたびに変更されます。",
    "profile.label.2Fa.app.setup.note1_1": "2.アプリを設定<br/>ダウンロード完了後、以下のリンクからアカウント情報を設定または認証キーの入力、いずれかの方法にてアプリを設定してください。設定後に認証コード（6桁の数字）を取得してください。",
    "profile.label.2Fa.app.setup.note1": "■Google Authenticatorをインストールされていない場合はダウンロード画面が開きます。",
    "profile.label.login_notify.title": "ログインアラート",
    "profile.label.second_pass.title": "第2パスワードアラート",
    "profile.label.login_notify.note1": "新しい端末やIPからログインされた場合に、ログイン時間などをメールでお知らせする機能です。",
    "profile.label.login_notify.note2": "お客様のログインアカウントが第三者によって不正に利用されていないかを確認できます。",
    "profile.label.second_pass_alert.note1": "第2パスワードを入力された場合に、成功・失敗をメールでお知らせする機能です。",
    "profile.label.second_pass_alert.note2": "お客様の口座が第三者によって不正に利用されていないかを確認できます。",
    "profile.label.screen.2fa.save": "設定する",
    "profile.label.2Fa.question1": "ログイン2段階認証（2FA）とは",
    "profile.label.2Fa.question2": "2段階認証は、ログイン時にIDとパスワードの確認に加えて、Google 認証システムにより生成された認証コードによる確認を追加することで、第三者による不正ログインを防ぐための機能です。 一度、認証コードを入力した端末では、2回目以降の認証コードの入力は一定期間不要です。",
    "profile.label.second_password.2Fa.question1": "出金2段階認証（2FA）とは",
    "profile.label.second_password.2Fa.question2": "2段階認証は、出金時の第2パスワードに加えて、Google 認証システムにより生成された認証コードによる確認を追加することで、第三者による不正操作を防ぐための機能です。 一度、認証コードを入力した端末では、2回目以降の認証コードの入力は一定期間不要です。",
    "profile.label.security.setting": "セキュリティー設定",
    "profile.label.screen.login_notify_flg.off": "通知しない",
    "profile.label.screen.login_notify_flg.main_mail": "メインメールに通知する",
    "profile.label.screen.login_notify_flg.additional_mail": "追加メールに通知する",
    "profile.label.screen.login_notify_flg.on": "メインメールと追加メールに通知する",
    "profile.label.2Fa.app.note.off": "2段階認証を解除するには、認証コード（6桁の数字）の入力が必要です。",
    "profile.label.address.invidual.after_upload.2.new": "※アップロード以外の送付方法や提出書類の詳細は、<a href=\"{param}\" target=\"_blank\">必要書類について</a>をご覧ください。",
    "profile.label.address.corporation.after_upload.1.new": "法人住所を変更される場合、変更後の情報が記載されている履歴事項全部証明書（発行から3ヶ月以内）のご提出が必要です。上のアップロードフォームより送信をお願いいたします。アップロード以外の送付方法や提出書類の詳細は、<a href=\"{param}\" target=\"_blank\">必要書類について</a>をご覧ください。 <br>また原則、住所変更の際に法人番号書類のご提出も必要となります。本ページ下部の提出ボタンより送信をお願いいたします。",
    "profile.label.id.document.upload": "ファイルアップロード",
    "profile.label.id.document.upload.title": "アップロード",

    "profile.label.fido.passkey.registration.label": "パスキーの登録機能",
    "profile.label.fido.verify.authentication.note": "お客様氏名などマスキングの解除、ならびに登録情報の変更手続きには、ご本人確認としてパスキー認証またはワンタイムパスワード認証が必要です。",
    "profile.label.fido.passkey.status.unset.yet": "未登録",
    "profile.label.fido.passkey.status.already.set": "登録済み",
    "profile.label.fido.authentication.alert": "パスキー認証成功通知",
    "profile.label.fido.authentication.alert.main.mail": "メインメール",
    "profile.label.fido.authentication.alert.additional.mail": "追加メール",

    "dashboard.btn.update.time": "更新",
    "dashboard.label.mypage": "ホーム",
    "dashboard.label.total_equity": "純資産合計",
    "dashboard.label.equity_ntd": "純資産額",
    "dashboard.label.equity_crypt": "純資産額",
    "dashboard.label.equity": "有効証拠金",
    "dashboard.label.equity.sc.internal": "有効証拠金",
    "dashboard.label.equity.sc.public": "純資産額",
    "dashboard.label.balance": "口座残高",
    "dashboard.label.reserved_amount": "出金予約額",
    "dashboard.label.unrealize_pl": "評価損益等",
    "dashboard.label.deposit": "預金",
    "dashboard.label.transferto": "への転送",
    "dashboard.label.system": "システム",
    "dashboard.label.news": "お知らせ",
    "dashboard.label.news_list": "お知らせ一覧",
    "dashboard.label.service": "商品",
    "dashboard.label.category": "カテゴリー",
    "dashboard.label.read_flg": "未読のみ",
    "dashboard.title.summary": "資産サマリー",
    "dashboard.title.time": "更新時間",
    "dashboard.title.phone_app": "iPhone / Android アプリ",
    "dashboard.title.phone_app.ios": "iPhone",
    "dashboard.title.phone.app.ios": "iPhone アプリ",
    "dashboard.title.phone_app.android": "Android アプリ",
    "dashboard.title.fx": "ＦＸトレーダー　",
    "dashboard.title.fx.note": "FX口座",
    "dashboard.title.st": "システムトレーダー",
    "dashboard.title.st.note": "シストレ口座",
    "dashboard.title.bo": "オプショントレーダー",
    "dashboard.title.bo.note": "オプション口座",
    "dashboard.title.crypt": "コイントレーダー",
    "dashboard.title.crypt_app": "コインレーダー",
    "dashboard.title.crypt.note": "コイン口座",
    "dashboard.title.mypage": "マイページ",
    "dashboard.title.dashboard": "自宅",
    "dashboard.title.bo.web": "Webブラウザ版",
    "dashboard.title.dashboard.welcom": "ダッシュボードのマイページへようこそ",

    "nts.prefecture.default": "選択して下さい",
    "nts.prefecture.hokkaidou": "北海道",
    "nts.prefecture.aomori": "青森県",
    "nts.prefecture.iwate": "岩手県",
    "nts.prefecture.miyagi": "宮城県",
    "nts.prefecture.akita": "秋田県",
    "nts.prefecture.yamagata": "山形県",
    "nts.prefecture.fukushima": "福島県",
    "nts.prefecture.ibaraki": "茨城県",
    "nts.prefecture.tochigi": "栃木県",
    "nts.prefecture.gunma": "群馬県",
    "nts.prefecture.saitama": "埼玉県",
    "nts.prefecture.chiba": "千葉県",
    "nts.prefecture.tokyo": "東京都",
    "nts.prefecture.kanagawa": "神奈川県",
    "nts.prefecture.niigata": "新潟県",
    "nts.prefecture.toyama": "富山県",
    "nts.prefecture.ishikawa": "石川県",
    "nts.prefecture.fukui": "福井県",
    "nts.prefecture.yamanashi": "山梨県",
    "nts.prefecture.nagano": "長野県",
    "nts.prefecture.gifu": "岐阜県",
    "nts.prefecture.shizuoka": "静岡県",
    "nts.prefecture.aichi": "愛知県",
    "nts.prefecture.mie": "三重県",
    "nts.prefecture.shiga": "滋賀県",
    "nts.prefecture.kyouto": "京都府",
    "nts.prefecture.oosaka": "大阪府",
    "nts.prefecture.hyougo": "兵庫県",
    "nts.prefecture.nara": "奈良県",
    "nts.prefecture.wakayama": "和歌山県",
    "nts.prefecture.tottori": "鳥取県",
    "nts.prefecture.shimane": "島根県",
    "nts.prefecture.okayama": "岡山県",
    "nts.prefecture.hiroshima": "広島県",
    "nts.prefecture.yamaguchi": "山口県",
    "nts.prefecture.tokushima": "徳島県",
    "nts.prefecture.kagawa": "香川県",
    "nts.prefecture.ehime": "愛媛県",
    "nts.prefecture.kouchi": "高知県",
    "nts.prefecture.fukuoka": "福岡県",
    "nts.prefecture.saga": "佐賀県",
    "nts.prefecture.nagasaki": "長崎県",
    "nts.prefecture.kumamoto": "熊本県",
    "nts.prefecture.ooita": "大分県",
    "nts.prefecture.miyazaki": "宮崎県",
    "nts.prefecture.kagoshima": "鹿児島県",
    "nts.prefecture.okinawa": "沖縄県",

    "kickbackHistory.date": "日付",
    "kickbackHistory.no_of_person": "成果人数",
    "kickbackHistory.kickback_amount": "アフィリエイト報酬",
    "kickbackHistory.type": "タイプ",
    "kickback.type.traded_complete": "取引済み",
    "kickback.type.deposit_complete": "入金済み",
    "kickback.type.waiting": "申込手続中 ",

    "history.transaction.type.deposit": "入金",
    "history.transaction.type.withdrawl": "出金 ",
    "history.transaction.type.trading_loss": "取引損",
    "history.transaction.type.social_fee_in": "報酬入金",
    "history.transaction.type.social_fee_out": "報酬出金",
    "history.transaction.type.transfer": "振替 ",
    "history.transaction.type.cashback": "キャッシュバック",
    "history.transaction.type.other": "その他",
    "history.transaction.type.cashback_in": "キャッシュバック入金",
    "history.transaction.type.cashback_out": "キャッシュバック出金",
    "history.transaction.type.social_affiliate_in": "ソーシャルアフィリエイト入金",
    "history.transaction.type.social_affiliate_out": "ソーシャルアフィリエイト出金",
    "history.transaction.type.swap_in": "スワップ入金",
    "history.transaction.type.swap_out": "スワップ出金",
    "history.transaction.type.trading_profit": "取引益",
    "history.transaction.type.credit_in": "の信用",
    "history.transaction.type.credit_out": "クレジットアウト",
    "history.transaction.type.cash_credit_in": "現金クレジットで",
    "history.transaction.type.cash_credit_out": "現金クレジットアウト",
    "history.transaction.type.adjust_in": "その他入金",
    "history.transaction.type.adjust_out": "その他出金",
    "history.transaction.type.adjust_spot_pl": "取引損益調整",
    "history.transaction.type.adjust_swap_pl": "スワップ損益調整",
    "history.transaction.type.adjust_balance_in": "残高調整入金",
    "history.transaction.type.adjust_balance_out": "残高調整出金",
    "history.transaction.type.adjust_tranfer_in": "振替調整入金",
    "history.transaction.type.adjust_tranfer_out": "振替調整出金",
    "history.transaction.method.bankwire": "銀行送金",
    "history.transaction.type.vitual_account": "仮想口座",
    "history.transaction.type.direct_deposit": "ダイレクト預金",
    "history.transaction.status.requesting": "予約中",
    "history.transaction.status.inprogress": "処理中",
    "history.transaction.status.success": "完了",
    "history.transaction.status.cancel": "キャンセル",
    "history.cb.deposit.status": "--- ステータス ---",
    "history.cb.deposit.method": "--- 方法 ---",
    "history.cb.transaction.type": "--- 種別 ---",
    "history.title.mypage": "マイページ",
    "history.title.history": "履歴",
    "history.title.history2": "入出金履歴",
    "history.label.transaction_type": "種別",
    "history.label.status": "ステータス",

    "login.history.label" : "ログイン履歴",
    "login.history.describe" : "過去90日間のログイン履歴を最大100件までご確認いただけます。",
    "login.history.table.login.time" : "ログイン日時",
    "login.history.table.os" : "OS",
    "login.history.table.browser.or.app" : "ブラウザ/アプリ",
    "login.history.table.authentication.method" : "認証方式",
    "login.history.table.ip.address" : "IPアドレス",
    "login.history.table.status" : "ステータス",

    "nts.ams.fe.label.history.table.header.transactionId": "受付番号",
    "nts.ams.fe.label.history.table.header.customerid": "口座番号",
    "nts.ams.fe.label.history.table.header.customername": "氏名",
    "nts.ams.fe.label.history.table.header.type": "種別",
    "nts.ams.fe.label.history.table.header.method": "方法",
    "nts.ams.fe.label.history.table.header.amount": "金額",
    "nts.ams.fe.label.history.table.header.date": "日時",
    "nts.ams.fe.label.history.table.header.source": "出金元",
    "nts.ams.fe.label.history.table.header.destination": "入金・振替先",
    "nts.ams.fe.label.history.table.header.status": "ステータス",
    "nts.ams.fe.label.history.table.header.cancel": "取消",
    "nts.ams.fe.label.bank_information.bankTransfer.bank": "銀行は必須です。",
    "nts.ams.fe.label.bank_information.bankTransfer.branch": "支店は必須です。",
    "nts.ams.fe.label.bank_information.bankTransfer.accountNumber": "口座番号は必須です。",
    "nts.ams.fe.testbo.legal1": "バイナリーオプション投資を的確に行うためには、オプション取引などデリバティブ取引に関わる知識や経験が必要となります。",
    "nts.ams.fe.testbo.legal2": "本テストはオプション取引に関わる基礎的な知識の有無を確認する目的で行われます。",
    "nts.ams.fe.testbo.legal3": "本テストの実施は法令で義務付けられており、お客様が当社の提供する店頭バイナリーオプション取引を行うことに適した投資家であるかを当社が判断いたします。",
    "nts.ams.fe.testbo.legal4": "本テストの結果により適正と判断し、取引を開始する場合は、当社の承認完了後に取引開始となります。",
    "nts.ams.fe.testbo.legal5": "本テストの結果により適正と判断し、取引を開始する場合は、その後当社との間に取引上のトラブルが生じたとしても、オプション取引に関わる知識が不足していたにも関わらず当社が取引を認めたことを訴因とはしないことに同意します。",
    "nts.ams.fe.testbo.legal6": "問題の複写や第三者に問題を漏えいすることは厳禁です。",
    "nts.ams.fe.testbo.agree": "「みんなのオプション」をご利用するには、知識確認テストに合格する必要があります。不合格の場合、翌日以降に再度実施できます。",
    "nts.ams.fe.testbo.questionTitle": "知識確認テスト",
    "nts.ams.fe.testbo.checkinfo": "知識確認テスト開始前の同意事項",
    "nts.ams.fe.testbo.correct_answer": "問",
    "nts.ams.fe.testbo.total_answer": "問中",

    "payment_method.bank": "出金",
    "payment_method.payza": "Payza",
    "payment_method.paypal": "Paypal",
    "payment_method.neteller": "Neteller",
    "payment_method.liberty": "Liberty Reserve",
    "payment_method.credit.debit": "Credit/Debit Card",
    "payment_method.virtual.account": "バーチャル入金",
    "payment_method.direct.deposit": "ダイレクト入金",
    "payment_method.exchanger": "Exchanger/Local Transfer",

    "deposit.mail.cancel.reason": "取引はキャンセルされました。",
    "confirm.cancel.transaction": "出金予約を取消しますか？",

    "bank.account.method": "入出金",
    "bank.account.bank_name": " 銀行名",
    "bank.account.branch_name": "支店名",
    "bank.account.account_type": "口座種別",
    "bank.account.account_number": "口座番号",
    "bank.account.account_name": "口座名義",
    "bank.account.note": "上記口座にお振込みいただきますと、着金確認後、入出金口座に反映いたします。",
    "bank.account.type.normal": "普通預金",
    "bank.account.type.current_deposit": "当座預金",
    "bank.account.type.saving_deposit": "貯蓄預金",
    "bank.account.popup.bank_search": "金融機関検索",
    "bank.account.popup.branch_search": "支店の検索",
    "bank.account.popup.search_bank_name": "金融機関名から検索",
    "bank.account.popup.search_branch_name": "支店名から検索",
    "bank.account.popup.bank_code": "金融機関コード",
    "bank.account.popup.bank_name": "金融機関名",
    "bank.account.popup.branch_code": "支店コード",
    "bank.account.popup.branch_name": "支店名",
    "bank.account.popup.selection": "選択 ",
    "bank.account.label.trader_secure": "ティーアールエス",
    "bank.account.title.mypage": "マイページ",
    "bank.account.title.bank_accounts": "出金先口座登録・変更",
    "bank.account.title.bank_accounts_2": "出金先となる金融機関",
    "bank.account.label.bank_name": "銀行名",
    "bank.account.label.bank_branch": "支店名",
    "bank.account.label.account_type": "口座種別",
    "bank.account.label.account_number": "口座番号",
    "bank.account.label.account_name": "口座名義",
    "bank.account.button.search_bank": "その他の金融機関",
    "bank.account.button.search_branch": "支店検索",
    "bank.account.button.save": "登録・変更",
    "bank.account.button.cancel": "キャンセル",
    "bank.name": "銀行",
    "bank.account.class.normal": "普通預金",
    "bank.account.class.current": "当座預金",
    "bank.account.class.saving": "貯蓄預金",
    "bank.account.label.edit_add": "Edit/Add Account Information",
    "bank.account.label.withdraw_bank": "出金",
    "bank.account.label.virtual_payment": "バーチャル入金",
    "bank.account.note.text0" : "銀行情報の更新が必要です。",
    "bank.account.note.text1": "現在、出金処理中です。出金完了まで出金先口座の変更は行えません。",
    "bank.account.note.text2": "現在、出金先口座の登録・変更手続き中です。完了まで今しばらくお待ちください。",
    "bank.account.upload.file.text": "画像を選択 ",
    "bank.account.label.upload.file": "選択フアイル ",

    "deposit.title.mypage": "マイページ",
    "deposit.title.deposit": "ダイレクト入金",
    "deposit.title.transfer_payment": "振込入金",
    "deposit.label.money": "円",
    "deposit.label.select_bank_account": "利用金融機関",
    "deposit.label.ams_account": "AMSアカウント",
    "deposit.label.amount": "金額",
    "deposit.label.deposit": "ダイレクト入金実行",
    "deposit.button.anotherbank": "出金先口座登録・変更",
    "deposit.label.another_bank": "他行",
    "deposit.label.to": "に",
    "deposit.title.info1": "銀行窓口、銀行ATM、およびネットバンキングから以下の口座に銀行振込をしていただくことが可能です。着金確認後、入出金口座に反映いたします。",
    "deposit.title.info2": "振込専用口座情報",
    "deposit.label.bank_name": "銀行名",
    "deposit.label.branch_name": "支店名",
    "deposit.label.account_type": "口座種別",
    "deposit.label.account_number": "口座番号",
    "deposit.label.account_holder": "口座名義",
    "deposit.message.not_used": "ﾄﾚｲﾀﾞｰｽﾞｼﾖｳｹﾝｶﾌﾞｼｷｶﾞｲｼﾔ",
    "deposit.header": "入金",
    "deposit.header.1": "1. 入金元の金融機関を選択",
    "deposit.header.2": "3. 入金金額を入力",
    "deposit.header.3": "2. 入金先の口座を選択",
    "deposit.button.help": `入金でお困りの方はこちら`,
    "deposit.button.help.url": `${Config.getDepositHelpUrl()}`,

    "label.affiliate": "アフィリエイト報酬",
    "label.totalAmount": "金額",
    "label.cashBack": "キャッシュバック",
    "label.begin": "期首",
    "label.end": "期末",
    "label.increase/decrease": "対象期間における増減額",
    "label.fee": "手数料",
    "label.total": "合計",
    "label.cashBack.square.brackets": "【キャッシュバック】",

    "withdraw.title.withdraw": "出金",
    "withdrawal.title.request": "出金依頼",
    "withdrawal.title.confirm": "出金情報",
    "withdrawal.placeholder.amount": "金額入力",
    "withdrawal.available.amount": "出金可能金額",
    "withdrawal.ams.available.amount": "出金可能額",
    "withdrawal.other.available.amount": "振替可能額",
    "withdraw.label.money": "円",
    "withdraw.bank.info": "出金先口座",
    "withdraw.label.bank_name": "銀行名",
    "withdraw.label.branch_name": "支店名",
    "withdraw.label.account_type": "口座種別",
    "withdraw.label.account_number": "口座番号",
    "withdraw.label.account_name": "口座名義",
    "withdraw.button.choose": "選択",
    "withdraw.button.edit": "編集",
    "withdraw.button.delete": "削除",
    "withdraw.button.new_payment": "出金先口座登録・変更",
    "withdraw.button.request.execute": "出金依頼実行",
    "withdraw.note": "・出金依頼は原則1営業日1回、かつ{min}円以上から可能です。{min}円未満の出金は全額出金のみ対応が可能となります。",
    "withdraw.note.2": "・当社約款に従い、原則3営業日以内にお客様がご登録された出金先口座へお振込みいたします。ただし、土日祝を除く営業日の午前11時までにご依頼いただいた出金依頼に関しましては、原則当日中の出金となります。",
    "withdraw.note.3": "・出金依頼を行うと、「入出金口座」のうち依頼された金額を出金先口座にお振込みいたします。",
    "withdraw.note.4": "・出金先口座の金融機関や支店等（出張所含む）の統廃合が実施された場合、金融機関コード、支店コードが変更される場合がございますので、金融機関ならびに支店の名称に変更がない場合でも出金先口座の再登録による情報の更新をお願いいたします。",
    "withdraw.note.5" : "・ご指定いただいた出金先口座とは別の金融機関口座の登録をお願いする場合があります。",
    "withdraw.table.name": "ご依頼中の出金",
    "withdraw.header.withdrawal_number": "出金番号",
    "withdraw.header.date_time": "依頼日時",
    "withdraw.header.method": "方法",
    "withdraw.header.amount": "金額",
    "withdraw.header.status": "ステータス",
    "withdraw.header.source": "出金元口座",
    "withdraw.header.cancel": "取消",
    "withdraw.label.withdrawal_amount": "出金金額",
    "withdraw.label.method": "出金方法",
    "withdraw.label.payment_info": "出金先情報",
    "withdraw.label.withdrawal_method": "出金方法",
    "withdraw.label.bank_wire": "銀行振込",
    "withdraw.label.withdrawal_fee": "出金手数料",
    "withdraw.label.receipt_amount": "受取金額",
    "withdraw.label.confirm": " 確認",
    "withdraw.label.back": " 戻る",
    "withdraw.label.execute": "実行",
    "withdraw.requesting": "予約中",
    "withdraw.inprogress": "処理中",
    "withdraw.label.new_payment": "出金口座登録",
    "withdraw.cancel.request.confirm": "出金予約を取消しますか？",
    "withdraw.verify.passkey.note1": "出金先口座のマスキングの解除、ならびに出金先口座情報・出金依頼の手続きには、ご本人確認としてパスキー認証またはワンタイムパスワード認証が必要です。",
    "withdraw.note1_1": "各取引口座の資金を出金するためには、まず「入出金口座」に",
    "withdraw.note1_2": "資金振替",
    "withdraw.note1_3": "いただく必要があります。",
    "withdraw.note2": "各取引口座の振替可能額が0円またはマイナス表記の場合、入出金口座への資金振替および出金予約をいただけません。",
    "withdraw.note3": "出金予約はまだ完了しておりません。<br>画面下部の「確認」より出金予約いただけます。",
    "withdraw.button.help": `出金でお困りの方はこちら`,
    "withdraw.button.help.url": `${Config.getWithdrawalHelpUrl()}`,

    "transfer.title.mypage": "マイページ",
    "transfer.title.transfer": "振替",
    "transfer.from.account": "振替元口座",
    "transfer.to.account": "振替先口座",
    "transfer.amount": "振替金額",
    "transfer.from.account.info": "振替元口座情報",
    "transfer.amount.available": "振替可能額:",
    "transfer.to.account.info": "振替先口座情報",
    "transfer.label.confirmation": "振替",
    "transfer.button.label.transfer": "資金振替実行",
    "transfer.button.label.confirm": "確認",
    "transfer.button.label.back": "戻る",
    "transfer.dcb.service.type.ams": "入出金口座",
    "transfer.cb.service.type.bo": "オプション口座",
    "transfer.cb.service.type.social": "シストレ口座",
    "transfer.cb.service.type.ntd_fx": "FX口座",
    "transfer.cb.service.type.crypto_fx": "コイン口座",
    "transfer.label.transfer": "資金振替",
    "transfer.label.transfer_from": "1. <span class=\"text-warning\">振替元</span>の口座を選択",
    "transfer.label.transfer_to": "2. <span class=\"text-warning\">振替先</span>の口座を選択",
    "transfer.label.transfer_amount": "3. 振替金額を入力",
    "transfer.label.note": "FX口座、シストレ口座、オプション口座にてお取引いただくためには、入出金口座から各口座に資金振替をする必要がございます。",
    "transfer.label.amount": "振替金額",
    "transfer.label.note2": `振替可能額が0円となっている場合、<a href='${Config.getMyHelpUrl()}' target='_blank'>よくあるご質問</a>をご参照ください。`,

    "questionnaire.subject.structure.jp": "仕組み",
    "questionnaire.subject.method.jp": "方法",
    "questionnaire.subject.outline.jp": "概要",
    "questionnaire.subject.risk.jp": "リスク",
    "questionnaire.subject.calculation.jp": "計算",

    "bo.test.step1": "テスト質問",
    "bo.test.step2": "テスト確認",
    "bo.test.step3": "テスト結果",
    "bo.test.th.subject": "分野",
    "bo.test.th.result": "正解数",
    "bo.test.label.hints": "【ヒント】",
    "bo.test.button.hints": "ヒント",

    "trs.front.title.tab.mypage": "マイページ",
    "trs.front.title.tab.report": "報告書",
    "trs.front.title.box.report": "お客様報告書閲覧",
    "trs.front.title.tab.bank_account": "報告書閲覧",
    "trs.front.title.tab.account_info": "口座情報",
    "trs.front.title.tab.bo_test": "テスト",

    "trs.front.header.san.digist": "様",
    "trs.front.header.label.logout": "ログアウト",
    "trs.front.header.label.mypage": "マイページ",
    "trs.front.header.label.fx": "FX",
    "trs.front.header.label.fx.mobile": "ウェブトレーダー アプリ版",
    "trs.front.header.label.social": "シストレ",
    "trs.front.header.label.bo": "オプション",
    "trs.front.header.label.fx.new": "Webトレーダー",
    "trs.front.header.label.fx.express": "FXトレーダー",
    "trs.front.header.label.crypt": "コイン",
    "trs.front.header.label.fx.trade.app": "FX アプリを開く",
    "trs.front.header.label.system.trade.app": "シストレ アプリを開く",
    "trs.front.header.label.bo.trade.ios": "オプション",
    "trs.front.header.label.bo.trade.android": "オプションアプリを開く",
    "trs.front.header.label.bo.trade.app": "オプション",
    "trs.front.header.label.crypto.trade.app": "コインアプリを開く",
    "trs.front.bo.registration.note": "いつも「みんなのＦＸ」及び「みんなのオプション」をご愛顧いただき、誠にありがとうございます。この度、「みんなのオプション」をご利用いただくにあたり、追加の確認事項がございますのでご選択およびご回答いただきますようよろしくお願いいたします。",
    "trs.front.bo.registration.label.purpose": "バイナリー投資目的",
    "trs.front.bo.registration.label.short_term": "短期収益の重視",
    "trs.front.bo.registration.label.dispersion": "分散した資産運用",
    "trs.front.bo.registration.label.hedge": "ヘッジ目的",
    "trs.front.bo.registration.label.hedge_type": "ヘッジタイプ",
    "trs.front.bo.registration.label.hedge_amount": "ヘッジ金額",
    "trs.front.bo.registration.label.max_loss_amount": "バイナリー損失上限額",
    "trs.front.bo.registration.label.success": "ご登録情報の更新が完了しました。",
    "trs.front.bo.registration.mess.require": "Field required is not fill",

    "trs.front.crypto.registration.label.purpose": "暗号資産CFD投資目的",
    "trs.front.crypto.registration.label.fluctuations.crypto.value": "暗号資産の価格変動による売却益のため",
    "trs.front.crypto.registration.label.diversified.investment": "分散投資をおこなうため",
    "trs.front.crypto.registration.label.asset.formation": "資産形成のため",
    "trs.front.crypto.registration.label.hedge_type": "ヘッジタイプ",
    "trs.front.crypto.registration.label.hedge_amount": "ヘッジ金額",
    "trs.front.crypto.registration.label.exp": "投資経験：暗号資産",
    "trs.front.crypto.registration.label.success": "コイン口座の開設が完了いたしました。",
    "trs.front.crypto.registration.mess.require": "Field required is not fill",
    "trs.front.crypto.registration.note": "私は店頭暗号資産証拠金取引に関する「取引説明書」及び「取引約款」の内容を確認し、各取引の仕組み、内容、リスク等を十分に理解した上で、私の判断と責任において当該取引を行います。",
    "trs.front.crypto.registration.please_choose": "選択してください",
    "trs.front.crypto.registration.over_5 _years": "5年以上",
    "trs.front.crypto.registration.less_than_5_years": "5年未満",
    "trs.front.crypto.registration.less_than_4_years": "4年未満 ",
    "trs.front.crypto.registration.less_than_3_years": "3年未満 ",
    "trs.front.crypto.registration.less_than_2_years": "2年未満 ",
    "trs.front.crypto.registration.less_than_1_years": "1年未満 ",
    "trs.front.crypto.registration.no_experience": "未経験",

    "trs.front.crypto.document.title": "必要書類のご提出",
    "trs.front.crypto.upfile.doc.status": "お客様の提出状況",
    "trs.front.crypto.upfile.id.status": "本人確認書類",
    "trs.front.crypto.upfile.tab1": "オンラインで提出",
    "trs.front.crypto.upfile.tab2": "郵送で提出",
    "trs.front.crypto.upfile.need": "必要書類について",
    "trs.front.crypto.upfile.id.form": "本人確認書類",
    "trs.front.crypto.upfile.mynumber.docs": "マイナンバー書類",
    "trs.front.crypto.upfile.corp.mynumber.docs": "法人番号指定通知書",
    "trs.front.crypto.upfile.personal.transaction.docs": "取引担当者の本人確認書類",
    "trs.front.crypto.upfile.Corporate.mynumber.notice": "法人番号指定通知書",
    "trs.front.crypto.upfile.personal.certificate.history.docs": "履歴事項全部証明書",
    "trs.front.crypto.upfile.on.web": "アップロード",
    "trs.front.crypto.upfile.select.file": "選択ファイル",
    "trs.front.crypto.button.select_file": "ファイルを選択",
    "trs.front.crypto.button.change_file": "変更",
    "trs.front.crypto.upfile.select.img": "画像を選択",
    "trs.front.crypto.upfile.file.extension": "本人確認書類をアップしてください 。(JPG, JPEG, BMP, GIF, TIF, TIFF, PNG, PDF)",
    "trs.front.crypto.upfile.indiv.mynumber.file.extension": "マイナンバー書類をアップしてください 。(JPG, JPEG, BMP, GIF, TIF, TIFF, PNG, PDF)",
    "trs.front.crypto.upfile.corp.personal.transaction.file.extension": "取引担当者様の本人確認書類をアップしてください 。(JPG, JPEG, BMP, GIF, TIF, TIFF, PNG, PDF)",
    "trs.front.crypto.upfile.corp.personal.certificate.history.file.extension": "履歴事項全部証明書をアップしてください 。(JPG, JPEG, BMP, GIF, TIF, TIFF, PNG, PDF)",
    "trs.front.crypto.upfile.corp.mynumber.file.extension": "法人番号指定通知書をアップしてください 。(JPG, JPEG, BMP, GIF, TIF, TIFF, PNG, PDF)",
    "trs.front.crypto.regis.invest.exp.less_than_1_month": "1ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_2_month": "2ヶ月未満 ",
    "trs.front.crypto.regis.invest.exp.less_than_3_month": "3ヶ月未満  ",
    "trs.front.crypto.regis.invest.exp.less_than_4_month": "4ヶ月未満  ",
    "trs.front.crypto.regis.invest.exp.less_than_5_month": "5ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_6_month": "6ヶ月未満 ",
    "trs.front.crypto.regis.invest.exp.less_than_7_month": "7ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_8_month": "8ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_9_month": "9ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_10_month": "10ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_11_month": "11ヶ月未満",
    "trs.front.crypto.regis.invest.exp.less_than_12_month": "12ヶ月未満",

    "trs.transfer.lable.tooltip.sc.internal": "FX口座純資産額＋シストレ口座有効証拠金＋オプション口座残高＋入出金口座残高－出金予約額",
    "trs.transfer.lable.tooltip.sc.public": "FX口座純資産額＋シストレ口座純資産額＋オプション口座残高＋コイン口座純資産額＋入出金口座残高－出金予約額",

    "trs.withdrawal.lable.tooltip.pc1": "出金するには各取引口座から「入出金口座」へ資金振替を行ってから出金予約をお願いいたします。",
    "trs.withdrawal.lable.tooltip.pc2": "各取引口座の振替可能額が0円またはマイナス表記の場合、入出金口座への資金振替および出金予約をいただけません。",
    "trs.withdrawal.lable.tooltip.pc3": "各取引口座の残高やポジション状況をご確認願います。",
    "trs.withdrawal.lable.tooltip.mobile1": "出金するには各取引口座から「入出金口座」",
    "trs.withdrawal.lable.tooltip.mobile2": "へ資金振替を行ってから出金予約をお願いいたします。",
    "trs.withdrawal.lable.tooltip.mobile3": "各取引口座の振替可能額が0円またはマイナス表記の場合、",
    "trs.withdrawal.lable.tooltip.mobile4": "入出金口座への資金振替および出金予約をいただけません。",
    "trs.withdrawal.lable.tooltip.mobile5": "各取引口座の残高やポジション状況をご確認願います。",

    "customer.support.label.1": "お客様サポート",
    "customer.support.label.2": "お取引マニュアル",
    "customer.support.label.3": "PC版",
    "customer.support.label.4": "マイページ",
    "customer.support.label.5": "システムトレーダー",
    "customer.support.label.6": "シストレ口座",
    "customer.support.label.7": "FXトレーダー",
    "customer.support.label.8": "ＦＸ口座",
    "customer.support.label.9": "Webトレーダー",
    "customer.support.label.10": "ＦＸ口座",
    "customer.support.label.11": "オプショントレーダー",
    "customer.support.label.12": "オプション口座",
    "customer.support.label.13": "アプリ版",
    "customer.support.label.14": "FXトレーダー",
    "customer.support.label.15": "ＦＸ口座",
    "customer.support.label.16": "システムトレーダー",
    "customer.support.label.17": "シストレ口座",
    "customer.support.label.18": "オプショントレーダー",
    "customer.support.label.19": "オプション口座",
    "customer.support.label.20": "よくあるご質問",
    "customer.support.label.21": "お客様からよくお寄せいただくご質問と、弊社からのご回答をホームページに掲載しております。",
    "customer.support.label.22": "よくあるご質問",
    "customer.support.label.23": "フォーム、お電話でのお問合せ",
    "customer.support.label.24": "フォームでのお問合せ",
    "customer.support.label.25": "お問合せフォーム",
    "customer.support.label.26": "お電話でのお問合せ",
    "customer.support.label.27" : "受付時間：",
    "customer.support.label.29": "スマホWEB版",
    "customer.support.label.30": "コイントレーダー",
    "customer.support.label.31": "コイン口座",
    "customer.pass2.note1": "お客様氏名などマスキングの解除、ならびに登録情報の変更手続きには第2パスワードの入力が必要です。",

    "change.login.id.popup.label.1": "ログインIDをメールアドレスに変更しますか？",
    "change.login.id.popup.label.2": "ログインIDがメインメールアドレスに変更されます。",
    "change.login.id.popup.label.3": "お客様のメインメールアドレス：",
    "change.login.id.popup.label.4": "※メインメールアドレスはお客様情報より変更可能です。",
    "change.login.id.popup.label.5": "まだ変更しません。",
    "change.login.id.popup.label.6": "現在、ご利用のログインＩＤは今後廃止を予定しております。",
    "change.login.id.popup.label.7": "メインメールアドレスがログインＩＤとなりますので、お早めに変更される事を推奨いたします。",
    "change.login.id.success.label.1": "ログインIDの変更が完了いたしました。",
    "change.login.id.success.label.2": "次回より、メインメールアドレスを",
    "change.login.id.success.label.3": "ログインIDとしてご利用ください。",
    "change.login.id.success.label.4": "お客様のメインメールアドレス：",
    "change.login.id.success.label.5": "※メインメールアドレスはお客様情報より変更可能です。",
    "change.login.id.fail.label": "更新できませんでした。再度、お試しください。",

    "dashboard.advertisement.url": "system/mypage-homebanner.php",
    "btn.agreement.news.skip": "Skip",

    "label.deposit.note1": "銀行法に基づく「電子決済等代行業者」に係る表示",
    "label.news.closeNews": "閉じる",
    "label.deposit.virtual_account.note1": "銀行窓口、ATM等より銀行振込でのご入金をご希望の場合、お客様専用のお振込先口座をご用意いたします。",
    "label.deposit.virtual_account.note2": "下記よりお申し込みください。",
    "label.deposit.btrn.virtual_account": "口座を作成する",
    "label.deposit.confirm_acc_virtual": "振込入金用の口座を作成しますか？",
    "label.deposit.confirm_acc_virtual.success": "振込入金用の口座作成が完了いたしました。下記ボタンより振込先をご確認ください。",

    "btn.2Fa.app.account.setup": "アカウント情報を設定",
    "bo_regis.investment_financial": "財務情報・投資経験",
    "label.cryptoFX.regulationCryptoFX": "各種規定の確認・承諾",
    "label.cryptoFX.regulationAttentionCoin":"店頭暗号資産証拠金取引に係るご注意",
    "label.cryptoFX.regulationOverviewCoin":"店頭暗号資産証拠金取引説明書",
    "label.cryptoFX.regulationRulesCoin":"店頭暗号資産証拠金取引約款",
    "label.cryptoFX.regulationInsiderCoin":"暗号資産内部者でないことの確認に関する同意書",
    "label.cryptoFX.coinTrading":"みんなのコイン取引（店頭暗号資産証拠金取引）に関する確認",

    //pass2
    "setup.pass2.label": "第2パスワード設定",
    "forgot.pass2.label": "!!",
    "form.pass2.title": "第2パスワードを入力してください",
    "btn.submit.pass2": "入力",
    "btn.cancel.pass2": "キャンセル",
    "btn.auth2.submit": "確認画面へ",
    "modal.pass2.title": "認証コードの入力",
    "modal.pass2.label": "認証アプリ(Google Authenticator)を開き、表示されている6桁の認証コードを入力してください。",
    "tooltip.message": "第2パスワードの入力が必要です",
    "withdrawal.warning.message": "【ご注意】<br>平日（月～金）の午前11時までにご依頼いただいた出金予約は、原則当日中の着金予定となります。<br>平日（月～金）の午前11時以降または、土日祝にご依頼いただいた出金予約は、翌営業日の着金予定となります。<br>また、全額をご出金された場合、各キャンペーン・プログラムの対象外となる可能性がございますので、キャンペーン等に参加中のお客様はご注意ください。",
    "main_mail_label": "メインメール",
    "additional_email_label": "追加メール",


    // Force News
    "force_news.fib.label": "金融資産・投資可能金額・BO損失上限額",

}
